import { Button, Table } from "rsuite";
import CheckIcon from "@rsuite/icons/Check";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import { useTranslation } from "react-i18next";
const { Cell } = Table;

const ActionCell = ({
  rowData,
  dataKey,
  onClick,
  onDelete,
  ...props
}: {
  rowData?: any;
  dataKey?: any;
  onClick: Function;
  onDelete: Function;
}) => {
  const { t } = useTranslation();
  return (
    <Cell {...props} style={{ padding: "6px" }}>
      <Button
        appearance="link"
        onClick={() => {
          onClick && onClick(rowData.id);
        }}
        title={t("EDIT")}
      >
        {rowData.editStatus === "EDIT" ? <CheckIcon /> : <EditIcon />}
      </Button>
      <Button
        appearance="link"
        onClick={() => {
          onDelete && onDelete(rowData.id);
        }}
        title={t("DELETE")}
      >
        <TrashIcon />
      </Button>
    </Cell>
  );
};

export default ActionCell;
